import { IFilter, Logic, Operator } from 'core-components/types'

import { filterAreaFields, FilterFields } from '../configs'

interface IFormFilters {
  country: string
  market: string
  partnerId: string
  partnerName: string
  initialFilters?: IFilter[]
}

const removeDuplicateFilters = (filters: IFilter[]): IFilter[] => {
  const uniqueObjects = filters.reduce((acc, filter) => {
    acc[filter.field] = filter
    return acc
  }, {})

  return Object.values(uniqueObjects)
}

export const getFormFilters = ({
  country,
  market,
  partnerId,
  partnerName,
  initialFilters,
}: IFormFilters) => {
  const initialFiltersWithoutFilterAreaFields = initialFilters
    ? initialFilters.filter((el) => !filterAreaFields.includes(el.field))
    : []

  const filters: IFilter[] = initialFiltersWithoutFilterAreaFields

  if (country) {
    filters.push({
      operator: Operator.EQUAL,
      field: FilterFields.Country,
      value: country,
    })
  }
  if (market) {
    filters.push({
      operator: Operator.EQUAL,
      field: FilterFields.GeoMarket,
      value: market,
    })
  }
  if (partnerId) {
    filters.push({
      operator: Operator.CONTAINS,
      field: FilterFields.PartnerId,
      value: partnerId,
    })
  }
  if (partnerName) {
    filters.push({
      operator: Operator.CONTAINS,
      field: FilterFields.CommunicationName,
      value: partnerName,
    })
  }

  return {
    logic: Logic.AND,
    filters: removeDuplicateFilters(filters),
  }
}
